import CustomerTargetOrderDetail from '../../customer/TargetOrder/CustomerTargetOrderDetail'

export const TraderTargetOrderDetail = CustomerTargetOrderDetail

export default TraderTargetOrderDetail
